<template>
  <div>
    <chart-single-bar v-for="(skill, key) in sortedData" :data="skill" :key="key" :index="key"
                      class="mb-4"></chart-single-bar>
  </div>
</template>

<script>
import ChartSingleBar from "./ChartSingleBar";
import _ from "lodash";

export default {
  name: "Chart",
  components: {ChartSingleBar},
  props: {data: Object},
  computed: {
    sortedData() {
      return _.orderBy(this.data, ['points'], 'desc')
    }
  }
}
</script>

<style scoped>

</style>
